// Language strings for the application
export const strings = {
  gu: {
    // Landing Page
    ctaBecome: "સ્માર્ટ ખેડૂત બનો",
    tagline: "ખેતીના જાદુગર બનો!",
    benefits: {
      modern: "આધુનિક પદ્ધતિઓ",
      vedic: "વૈદિક ઉપાયો",
      personal: "વ્યક્તિગત માર્ગદર્શન",
      community: "સમુદાય સહાય",
    },
    pricing: {
      title: "Smart Farmer Premium",
      price: "₹999 / 3 વર્ષ",
      features: [
        "દરરોજ નવા પાઠ",
        "મોટાભાઈ સાથે સીધો સંપર્ક",
        "વિશેષ ટિપ્સ અને મદદ",
        "સમુદાયમાં જોડાઓ",
      ],
    },

    // Navigation
    todayLesson: "આજનો પાઠ",
    upcoming: "આગામી બ્રોડકાસ્ટ",
    chatWith: "મોટાભાઈ સાથે વાત કરો",
    notifications: "સૂચનાઓ",
    profile: "મારું પ્રોફાઇલ",

    // Subscription
    subscribe: "સબ્સ્ક્રાઇબ કરો (₹999 / 3 વર્ષ)",
    paySuccess: "ચુકવણી સફળ! આપનું સબ્સ્ક્રિપ્શન સક્રિય છે.",
    subscriptionActive: "સબ્સ્ક્રિપ્શન સક્રિય",
    subscriptionExpired: "સબ્સ્ક્રિપ્શન સમાપ્ત",
    renewsOn: "નવીકરણ તારીખ:",
    expiresOn: "સમાપ્તિ તારીખ:",
    limitedOffer: "*મર્યાદિત સમય માટે ઓફર ઉપલબ્ધ છે",

    // Video Player
    lockedWindow: "આ વિડિયો માત્ર નિર્ધારિત સમયગાળામાં ઉપલબ્ધ છે.",
    startsIn: "શરૂ થશે:",
    endsIn: "સમાપ્તિ:",
    playNow: "હવે જુઓ",
    notAvailable: "હાલમાં ઉપલબ્ધ નથી",

    // Chat
    send: "મોકલો",
    typeMessage: "સંદેશ લખો...",
    noMessages: "હજી કોઈ સંદેશ નથી",
    messageSent: "સંદેશ મોકલ્યો",
    motabhaiWillReply: "મોટાભાઈ જલ્દી જવાબ આપશે",
    askMotabhai: "મોટાભાઈને તમારો પ્રશ્ન પૂછો",

    // Common
    loading: "લોડ થઈ રહ્યું છે...",
    error: "ભૂલ થઈ",
    retry: "ફરી પ્રયાસ કરો",
    back: "પાછા",
    save: "સાચવો",
    cancel: "રદ કરો",
    confirm: "ખાતરી કરો",
    delete: "કાઢી નાખો",
    login: "લૉગિન",
    logout: "લૉગઆઉટ",
    today: "આજે",
    premium: "પ્રીમિયમ",
    processing: "પ્રોસેસ થઈ રહ્યું છે...",
    
    // Today Page
    newLessonAdded: "નવો પાઠ ઉમેર્યો!",
    newLessonAvailable: "નવો પાઠ ઉપલબ્ધ છે",
    noLessonsToday: "આજે કોઈ પાઠ નથી",
    viewUpcoming: "આગામી પાઠ જુઓ",
    waitForNextLesson: "આગામી પાઠ માટે રાહ જુઓ",
    
    // Subscribe Page
    whatYouGet: "તમને શું મળશે:",
    subscribeNow: "હવે સબ્સ્ક્રાઇબ કરો",
    oneYearFullAccess: "3 વર્ષ માટે સંપૂર્ણ એક્સેસ (1 વર્ષ + 2 વર્ષ મફત*)",
    subscriptionActivated: "તમારું સબ્સ્ક્રિપ્શન 3 વર્ષ માટે સક્રિય થયું છે.",
    securePayment: "સુરક્ષિત ચુકવણી | 100% સુરક્ષિત",
    dailyNew: "દરરોજ નવું",
    dailyNewDesc: "દરરોજ નવા પાઠ અને ટિપ્સ",
    directContact: "સીધો સંપર્ક",
    directContactDesc: "મોટાભાઈ સાથે ચેટ કરો",
    community: "સમુદાય",
    communityDesc: "હજારો ખેડૂતો સાથે જોડાઓ",
    
    // Upcoming Page
    newUpcomingLesson: "નવો આગામી પાઠ ઉપલબ્ધ છે",
    noUpcomingLessons: "કોઈ આગામી પાઠ નથી",
    newLessonsWillAppear: "નવા પાઠ ઉમેરાશે તો અહીં દેખાશે",
    
    // Promo Videos
    promoVideos: "પ્રોમો વીડિયો",
    watchPromoVideos: "પ્રોમો વીડિયો જુઓ",
    noPromoVideos: "કોઈ પ્રોમો વીડિયો નથી",
    newPromoVideosWillAppear: "નવા પ્રોમો વીડિયો ઉમેરાશે તો અહીં દેખાશે",
    
    // Subscription Required Messages
    subscriptionRequired: "સબ્સ્ક્રિપ્શન જરૂરી છે",
    subscriptionRequiredDesc: "આ વીડિયો જોવા માટે સબ્સ્ક્રિપ્શન જરૂરી છે",
    subscriptionRequiredMessage: "માત્ર ₹999 માં ત્રણ વર્ષની મફત એક્સેસ મેળવો!",
    subscriptionBenefits: [
      "આજના તમામ પાઠો",
      "આવનારા તમામ પાઠો",
      "સવાર અને સાંજ બંને સત્રો",
      "મોટાભાઈ સાથે સીધો સંપર્ક",
    ],
    subscribeToWatch: "હવે સબ્સ્ક્રાઇબ કરો",
    videoAvailableOn: "આ વીડિયો %DATE% ના રોજ ઉપલબ્ધ થશે",
    subscribeForAccess: "સબ્સ્ક્રાઇબ કરો અને સમયસર એક્સેસ મેળવો",
    
    // Notifications Page
    noNotifications: "કોઈ સૂચના નથી",
    newNotificationsWillAppear: "નવી સૂચના આવશે તો અહીં દેખાશે",

    // Profile
    editProfile: "પ્રોફાઇલ સંપાદિત કરો",
    name: "નામ",
    phone: "ફોન",
    whatsapp: "વ્હોટ્સએપ",
    languagePreference: "ભાષા પસંદગી",
    languageHelper: "તમારી ભાષા બદલવાથી લોગો પણ બદલાશે",
    adminPanel: "એડમિન પેનલ",

    // Auth
    welcomeBack: "પાછા આવવા બદલ આભાર!",
    enterPhone: "તમારો ફોન નંબર દાખલ કરો",
    sendOTP: "OTP મોકલો",
    verifyOTP: "OTP ચકાસો",
    enterOTP: "OTP દાખલ કરો",
    resendOTP: "OTP ફરી મોકલો",
    password: "પાસવર્ડ",
    newPassword: "નવો પાસવર્ડ",
    confirmPassword: "પાસવર્ડ કન્ફર્મ કરો",
    forgotPassword: "ભૂલી ગયા પાસવર્ડ?",
    passwordReset: "પાસવર્ડ રીસેટ",
    enterPhoneForReset: "તમારો મોબાઇલ નંબર દાખલ કરો",
    enterOtpAndPassword: "OTP અને નવો પાસવર્ડ દાખલ કરો",
    passwordResetSuccess: "પાસવર્ડ સફળતાપૂર્વક બદલાઈ ગયો",
    changePassword: "પાસવર્ડ બદલો",
    backToLogin: "લોગિન પર પાછા જાઓ",
    signUp: "નોંધણી",
    enterNameAndPhone: "તમારું નામ દાખલ કરો",
    yourNamePlaceholder: "તમારું નામ દાખલ કરો",
    enterPasswordPlaceholder: "તમારો પાસવર્ડ દાખલ કરો",
    enterNewPasswordPlaceholder: "નવો પાસવર્ડ દાખલ કરો",
    reEnterPasswordPlaceholder: "પાસવર્ડ ફરી દાખલ કરો",
    enterOtpPlaceholder: "6 અંકોનો OTP દાખલ કરો",
    getTempPassword: "ટેમ્પોરરી પાસવર્ડ મેળવો",
    clickToCreateAccount: "એકાઉન્ટ બનાવવા માટે ક્લિક કરો. તમને પાસવર્ડ મળશે.",
    alreadyHaveAccount: "પહેલેથી એકાઉન્ટ છે? લોગિન કરો",
    createNewAccount: "નવું એકાઉન્ટ બનાવો",
    backToHome: "હોમ પર પાછા જાઓ",
    yourTempPassword: "તમારો ટેમ્પોરરી પાસવર્ડ:",
    keepPasswordSafe: "કૃપા કરીને આ પાસવર્ડ સુરક્ષિત રાખો અને લોગિન પછી બદલો.",
    passwordCopied: "પાસવર્ડ કોપી થયો",
    yourPhoneAndPassword: "આપનો મોબાઇલ નંબર અને પાસવર્ડ દાખલ કરો",
    createNewAccountDesc: "નવું એકાઉન્ટ બનાવો",
    passwordResetSuccessful: "તમારો પાસવર્ડ સફળતાપૂર્વક બદલાઈ ગયો છે!",
    autoLoginSoon: "તમે આપમેળે લોગિન થઈ જશો...",
    enterValidPhone: "કૃપા કરીને માન્ય મોબાઇલ નંબર દાખલ કરો",
    enterPassword: "કૃપા કરીને પાસવર્ડ દાખલ કરો",
    enterName: "કૃપા કરીને તમારું નામ દાખલ કરો",
    loginSuccess: "લોગિન સફળ",
    accountCreated: "એકાઉન્ટ બનાવવામાં આવ્યું!",
    changePasswordAfterLogin: "કૃપા કરીને પ્રોફાઇલ સેટિંગ્સમાં પાસવર્ડ બદલો",
    otpSent: "OTP મોકલ્યો",
    passwordChanged: "પાસવર્ડ બદલાઈ ગયો",
    enterValidOtp: "કૃપા કરીને માન્ય OTP દાખલ કરો",
    passwordMinLength: "પાસવર્ડ ઓછામાં ઓછો 6 અક્ષરોનો હોવો જોઈએ",
    passwordMismatch: "પાસવર્ડ મેળ ખાતો નથી",

    // Admin Panel
    admin: {
      dashboard: "ડેશબોર્ડ",
      sessions: "સેશન મેનેજમેન્ટ",
      subscribers: "સબ્સ્ક્રાઇબર્સ",
      import: "એક્સેલથી આયાત",
      notifications: "સૂચનાઓ",
      chat: "ચેટ ક્વેરીઝ",
      reports: "રિપોર્ટ્સ",
      settings: "સેટિંગ્સ",
      
      stats: {
        totalSubscribers: "કુલ સબ્સ્ક્રાઇબર્સ",
        activeToday: "આજે સક્રિય",
        openChats: "ખુલ્લી ચેટ્સ",
        todaySessions: "આજના સેશન્સ",
      },

      session: {
        create: "નવું સેશન બનાવો",
        edit: "સેશન એડિટ કરો",
        title: "શીર્ષક (ગુજરાતી)",
        titleEn: "શીર્ષક (અંગ્રેજી)",
        description: "વર્ણન",
        youtubeId: "YouTube Video ID",
        date: "તારીખ",
        windows: "સમય વિંડોઝ",
        morning: "સવારે (7:00 - 10:00)",
        evening: "સાંજે (18:00 - 21:00)",
        notes: "નોંધો",
        status: "સ્થિતિ",
        draft: "ડ્રાફ્ટ",
        published: "પ્રકાશિત",
        expired: "સમાપ્ત",
      },
    },
  },
  
  hi: {
    // Landing Page
    ctaBecome: "स्मार्ट किसान बनें",
    tagline: "खेती के जादूगर बनें!",
    benefits: {
      modern: "आधुनिक तरीके",
      vedic: "वैदिक उपाय",
      personal: "व्यक्तिगत मार्गदर्शन",
      community: "समुदाय सहायता",
    },
    pricing: {
      title: "Smart Farmer Premium",
      price: "₹999 / 3 साल",
      features: [
        "रोज़ नए पाठ",
        "मोटाभाई के साथ सीधा संपर्क",
        "विशेष टिप्स और मदद",
        "समुदाय में शामिल हों",
      ],
    },

    // Navigation
    todayLesson: "आज का पाठ",
    upcoming: "आगामी प्रसारण",
    chatWith: "मोटाभाई से बात करें",
    notifications: "सूचनाएं",
    profile: "मेरी प्रोफ़ाइल",

    // Subscription
    subscribe: "सदस्यता लें (₹999 / 3 साल)",
    paySuccess: "भुगतान सफल! आपकी सदस्यता सक्रिय है।",
    subscriptionActive: "सदस्यता सक्रिय",
    subscriptionExpired: "सदस्यता समाप्त",
    renewsOn: "नवीकरण तिथि:",
    expiresOn: "समाप्ति तिथि:",
    limitedOffer: "*सीमित समय के लिए ऑफर उपलब्ध है",

    // Video Player
    lockedWindow: "यह वीडियो केवल निर्धारित समय में उपलब्ध है।",
    startsIn: "शुरू होगा:",
    endsIn: "समाप्ति:",
    playNow: "अभी देखें",
    notAvailable: "वर्तमान में उपलब्ध नहीं",

    // Chat
    send: "भेजें",
    typeMessage: "संदेश लिखें...",
    noMessages: "अभी तक कोई संदेश नहीं",
    messageSent: "संदेश भेजा गया",
    motabhaiWillReply: "मोटाभाई जल्द जवाब देंगे",
    askMotabhai: "मोटाभाई से अपना सवाल पूछें",

    // Common
    loading: "लोड हो रहा है...",
    error: "त्रुटि हुई",
    retry: "पुनः प्रयास करें",
    back: "वापस",
    save: "सहेजें",
    cancel: "रद्द करें",
    confirm: "पुष्टि करें",
    delete: "हटाएं",
    login: "लॉगिन",
    logout: "लॉगआउट",
    today: "आज",
    premium: "प्रीमियम",
    processing: "प्रोसेस हो रहा है...",
    
    // Today Page
    newLessonAdded: "नया पाठ जोड़ा गया!",
    newLessonAvailable: "नया पाठ उपलब्ध है",
    noLessonsToday: "आज कोई पाठ नहीं",
    viewUpcoming: "आगामी पाठ देखें",
    waitForNextLesson: "आगामी पाठ की प्रतीक्षा करें",
    
    // Subscribe Page
    whatYouGet: "आपको क्या मिलेगा:",
    subscribeNow: "अभी सदस्यता लें",
    oneYearFullAccess: "3 साल के लिए पूर्ण एक्सेस (1 साल + 2 साल फ्री*)",
    subscriptionActivated: "आपकी सदस्यता 3 साल के लिए सक्रिय हो गई है।",
    securePayment: "सुरक्षित भुगतान | 100% सुरक्षित",
    dailyNew: "रोज़ नया",
    dailyNewDesc: "रोज़ नए पाठ और टिप्स",
    directContact: "सीधा संपर्क",
    directContactDesc: "मोटाभाई के साथ चैट करें",
    community: "समुदाय",
    communityDesc: "हजारों किसानों के साथ जुड़ें",
    
    // Upcoming Page
    newUpcomingLesson: "नया आगामी पाठ उपलब्ध है",
    noUpcomingLessons: "कोई आगामी पाठ नहीं",
    newLessonsWillAppear: "नए पाठ जोड़े जाएंगे तो यहाँ दिखेंगे",
    
    // Promo Videos
    promoVideos: "प्रोमो वीडियो",
    watchPromoVideos: "प्रोमो वीडियो देखें",
    noPromoVideos: "कोई प्रोमो वीडियो नहीं",
    newPromoVideosWillAppear: "नए प्रोमो वीडियो जोड़े जाएंगे तो यहाँ दिखेंगे",
    
    // Subscription Required Messages
    subscriptionRequired: "सदस्यता आवश्यक है",
    subscriptionRequiredDesc: "यह वीडियो देखने के लिए सदस्यता आवश्यक है",
    subscriptionRequiredMessage: "केवल ₹999 में तीन साल की मुफ्त एक्सेस प्राप्त करें!",
    subscriptionBenefits: [
      "आज के सभी पाठ",
      "आगामी सभी पाठ",
      "सुबह और शाम दोनों सत्र",
      "मोटाभाई के साथ सीधा संपर्क",
    ],
    subscribeToWatch: "अभी सदस्यता लें",
    videoAvailableOn: "यह वीडियो %DATE% को उपलब्ध होगा",
    subscribeForAccess: "सदस्यता लें और समय पर एक्सेस प्राप्त करें",
    
    // Notifications Page
    noNotifications: "कोई सूचना नहीं",
    newNotificationsWillAppear: "नई सूचना आएगी तो यहाँ दिखेगी",
    
    // Profile
    editProfile: "प्रोफ़ाइल संपादित करें",
    name: "नाम",
    phone: "फ़ोन",
    whatsapp: "व्हाट्सऐप",
    languagePreference: "भाषा प्राथमिकता",
    languageHelper: "आपकी भाषा बदलने से लोगो भी बदल जाएगा",
    adminPanel: "एडमिन पैनल",
    
    // Auth
    welcomeBack: "वापस स्वागत है!",
    enterPhone: "अपना फ़ोन नंबर दर्ज करें",
    sendOTP: "OTP भेजें",
    verifyOTP: "OTP सत्यापित करें",
    enterOTP: "OTP दर्ज करें",
    resendOTP: "OTP पुनः भेजें",
    password: "पासवर्ड",
    newPassword: "नया पासवर्ड",
    confirmPassword: "पासवर्ड की पुष्टि करें",
    forgotPassword: "पासवर्ड भूल गए?",
    passwordReset: "पासवर्ड रीसेट",
    enterPhoneForReset: "अपना मोबाइल नंबर दर्ज करें",
    enterOtpAndPassword: "OTP और नया पासवर्ड दर्ज करें",
    passwordResetSuccess: "पासवर्ड सफलतापूर्वक बदल गया",
    changePassword: "पासवर्ड बदलें",
    backToLogin: "लॉगिन पर वापस जाएं",
    signUp: "साइन अप",
    enterNameAndPhone: "अपना नाम दर्ज करें",
    yourNamePlaceholder: "अपना नाम दर्ज करें",
    enterPasswordPlaceholder: "अपना पासवर्ड दर्ज करें",
    enterNewPasswordPlaceholder: "नया पासवर्ड दर्ज करें",
    reEnterPasswordPlaceholder: "पासवर्ड फिर से दर्ज करें",
    enterOtpPlaceholder: "6 अंकों का OTP दर्ज करें",
    getTempPassword: "अस्थायी पासवर्ड प्राप्त करें",
    clickToCreateAccount: "खाता बनाने के लिए क्लिक करें। आपको पासवर्ड मिलेगा।",
    alreadyHaveAccount: "पहले से खाता है? लॉगिन करें",
    createNewAccount: "नया खाता बनाएं",
    backToHome: "होम पर वापस जाएं",
    yourTempPassword: "आपका अस्थायी पासवर्ड:",
    keepPasswordSafe: "कृपया इस पासवर्ड को सुरक्षित रखें और लॉगिन के बाद बदलें।",
    passwordCopied: "पासवर्ड कॉपी किया गया",
    yourPhoneAndPassword: "अपना मोबाइल नंबर और पासवर्ड दर्ज करें",
    createNewAccountDesc: "नया खाता बनाएं",
    passwordResetSuccessful: "आपका पासवर्ड सफलतापूर्वक बदल गया है!",
    autoLoginSoon: "आप स्वतः लॉगिन हो जाएंगे...",
    enterValidPhone: "कृपया मान्य मोबाइल नंबर दर्ज करें",
    enterPassword: "कृपया पासवर्ड दर्ज करें",
    enterName: "कृपया अपना नाम दर्ज करें",
    loginSuccess: "लॉगिन सफल",
    accountCreated: "खाता बनाया गया!",
    changePasswordAfterLogin: "कृपया प्रोफ़ाइल सेटिंग्स में पासवर्ड बदलें",
    otpSent: "OTP भेजा गया",
    passwordChanged: "पासवर्ड बदल गया",
    enterValidOtp: "कृपया मान्य OTP दर्ज करें",
    passwordMinLength: "पासवर्ड कम से कम 6 अक्षरों का होना चाहिए",
    passwordMismatch: "पासवर्ड मेल नहीं खाते",
    
    // Admin Panel
    admin: {
      dashboard: "डैशबोर्ड",
      sessions: "सत्र प्रबंधन",
      subscribers: "सदस्य",
      import: "एक्सेल से आयात",
      notifications: "सूचनाएं",
      chat: "चैट",
      reports: "रिपोर्ट्स",
      settings: "सेटिंग्स",
      
      stats: {
        totalSubscribers: "कुल सदस्य",
        activeToday: "आज सक्रिय",
        openChats: "खुली चैट",
        todaySessions: "आज के सत्र",
      },

      session: {
        create: "नया सत्र बनाएं",
        edit: "सत्र संपादित करें",
        title: "शीर्षक (गुजराती)",
        titleEn: "शीर्षक (अंग्रेज़ी)",
        description: "विवरण",
        youtubeId: "YouTube Video ID",
        date: "तारीख",
        windows: "समय विंडोज़",
        morning: "सुबह (7:00 - 10:00)",
        evening: "शाम (18:00 - 21:00)",
        notes: "नोट्स",
        status: "स्थिति",
        draft: "मसौदा",
        published: "प्रकाशित",
        expired: "समाप्त",
      },
    },
  },
  
  en: {
    // Admin Panel (English only)
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    
    admin: {
      dashboard: "Dashboard",
      sessions: "Session Management",
      subscribers: "Subscribers",
      chat: "Chat Queries",
      backToDashboard: "Back to Dashboard",
      
      stats: {
        totalSubscribers: "Total Subscribers",
        activeSubscribers: "Active Subscribers",
        todaySessions: "Today's Sessions",
        openChats: "Open Chats",
      },

      session: {
        create: "Create New Session",
        edit: "Edit Session",
        title: "Title (Gujarati)",
        titleEn: "Title (English - Optional)",
        description: "Description (Gujarati)",
        youtubeId: "YouTube Video ID",
        date: "Session Date",
        windows: "Time Windows",
        morning: "Morning",
        evening: "Evening",
        customWindow: "Custom Window",
        addCustomWindow: "Add Custom Window",
        from: "From",
        to: "To",
        notes: "Internal Notes",
        status: "Status",
        draft: "Draft",
        published: "Published",
        expired: "Expired",
        
        // Tooltips
        tooltips: {
          title: "Enter the session title in Gujarati - this will be displayed to subscribers in the app",
          titleEn: "Optional English title for admin reference and tracking purposes only",
          description: "Brief description of the session content in Gujarati (shown to subscribers)",
          youtubeId: "Enter only the 11-character video ID from the YouTube URL. You can paste the full URL and we'll extract it automatically.",
          date: "Select the date when this session will be available to subscribers",
          windows: "Define specific time windows when subscribers can access this video during the selected date",
          notes: "Internal notes or special instructions - visible to admins only, not shown to subscribers",
          status: "Draft: Hidden from subscribers | Published: Visible to subscribers | Expired: No longer accessible",
        },
        
        // YouTube Helper
        youtube: {
          helper: "How to get YouTube Video ID",
          format1: "Standard URL: youtube.com/watch?v=",
          format2: "Short URL: youtu.be/",
          format3: "Embed URL: youtube.com/embed/",
          example: "Example: dQw4w9WgXcQ (11 characters)",
          pasteUrl: "💡 Tip: You can paste the full YouTube URL and we'll extract the ID automatically",
        },
        
        // Messages
        success: {
          created: "Session created successfully",
          updated: "Session updated successfully",
          deleted: "Session deleted successfully",
        },
        error: {
          required: "Please fill in all required fields",
          invalidYoutubeId: "Invalid YouTube Video ID (must be 11 characters)",
          failed: "Operation failed",
        },
        confirm: {
          delete: "Are you sure you want to delete this session?",
        },
      },
    },
  },
};

export type Language = 'gu' | 'hi' | 'en';
export type Strings = typeof strings.gu;

// Language display names
export const languageNames = {
  gu: "ગુજરાતી",
  hi: "हिंदी",
  en: "English"
};

// Default to Gujarati for subscriber pages
export const t = strings.gu;

// Admin English strings
export const tAdmin = strings.en;
